/*
 * Filename: component-config-root-component.tsx
 * Description: component for config root container.
 */

import React, { Component, ReactNode } from 'react';
import { ComponentFieldComponent } from './component-field';
import { observer } from 'mobx-react';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { Utility } from '../../../common/utility';
import TemplateConfigurationController from '../template-config.controller';
import { CQAppConstant } from '../../../app-constants';

interface IComponentConfigRootContainerProps {
    handleChange: any,
    updateIconName: (iconClassName: string) => void;
    componentFields: {
        templates: { [field: string]: string | {} }[],
        selectedTemplate: {}
    }[];
    selectedTemplateName: string;
    errors: any;
    resetAndDisableSelectionPanel: Function
}

class ComponentConfigRootContainer extends Component<IComponentConfigRootContainerProps, {componentName: string}> {
    private readonly templateConfigCtrl: TemplateConfigurationController;
    constructor(props: Readonly<IComponentConfigRootContainerProps>) {
        super(props);
        this.state = {
            componentName:''
        }
        this.templateConfigCtrl = new TemplateConfigurationController();
    }

    componentDidMount(){
        this.updateComponentName('selectedObject');
    }
    
    private updateComponentName =(key: string)=>{
        if(key !== 'componentName'){
            const outputConfigObject = CQMasterDataStore.OutputConfig.getStoreData(this.props.selectedTemplateName);
            const componentType = outputConfigObject['componentType'];
            let componentName = '';

            if([
                CQAppConstant.COMPONENT_TYPE_FLOW, 
                CQAppConstant.COMPONENT_TYPE_LIGHTNING_COMPONENT].includes(componentType)
            ) {
                componentName = outputConfigObject['componentName'];
            } else {
                componentName = this.templateConfigCtrl.generateComponentName(this.props.selectedTemplateName);
            }
            CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'componentName', componentName);
            this.setState({componentName});  
        }
    }

    render(): ReactNode {
        return (
            <>
                <div id="tab-default-1" className="slds-tabs_default__content slds-p-around_small full-height scroll-content" role="tabpanel"
                    aria-labelledby="tab-default-1__item">
                    <div className="slds-grid slds-gutters slds-wrap">
                    {
                        this.props.componentFields.length > 0 &&
                        this.props.componentFields.map((field: any, index: number) => {
                            return (<div className="slds-col slds-size--1-of-1 slds-medium-size--1-of-2 slds-large-size--1-of-2">
                                        <ComponentFieldComponent
                                            key={index}
                                            updateComponent={this.updateComponentName}
                                            errors={this.props.errors} fieldData={field}
                                            handleChange={this.props.handleChange}
                                            updateIconName={this.props.updateIconName}
                                            selectedTemplateName={this.props.selectedTemplateName}
                                            resetAndDisableSelectionPanel={(value: boolean) => this.props.resetAndDisableSelectionPanel(value)}
                                        />
                                    </div>);
                            })
                        }
                    </div>
                </div>
            </>
        );
    }

}
export default observer(ComponentConfigRootContainer);